import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TypographyWithOverflowTooltip } from "../Typographies/TypographyWithOverflowTooltip";
const CellContent = React.memo(({ displayValue }) => {
    const shouldWrapWithTooltip = typeof displayValue === "string";
    return shouldWrapWithTooltip ? (_jsx(TypographyWithOverflowTooltip, Object.assign({ typographyProps: { variant: "body2" } }, { children: displayValue }))) : (displayValue);
});
CellContent.displayName = "CellContent";
export default CellContent;
